import styled from 'styled-components';
import SVG from 'react-inlinesvg';

export const BannerContent = styled.div`
  align-items: center;
  background: ${props => props.theme.colors.background.secondary};
  display: grid;
  grid-gap: 24px;
  grid-template-columns: 1fr 1fr;
  opacity: ${props => props.theme.opacities.medium};
  padding: 0 32px;
`;

export const StyledSVG = styled(SVG)`
  margin-left: auto;
`;
